export default __webpack_public_path__ + "static/media/lasalleamanger.3f624a7d.png";